import { defineModule } from '../../manifest.js';
export const manifest = defineModule({
    moduleKey: 'crm',
    name: 'CRM',
    description: 'Accounts, contacts, opportunities and pipeline.',
    kind: 'commercial',
    sellable: true,
    navigationModuleKey: 'crm',
    features: [{ key: 'crm.forecasting', description: 'Weighted pipeline forecasting' }],
    editions: [
        { code: 'ed_01', description: 'Base edition', features: [], limits: ['user'] },
        {
            code: 'ed_02',
            description: 'Adds forecasting',
            features: ['crm.forecasting'],
            limits: ['user', 'active_user'],
        },
    ],
    limitTypes: ['user', 'active_user'],
    meteredEvents: [
    // Declared empty deliberately. This module is REGISTERED, not implemented:
    // what it meters is a decision that belongs to the stage that builds it,
    // and inventing metric keys now would put names into entitlement and
    // billing records before anybody designed them (S4-6).
    ],
    requiredCore: [
        'tenancy',
        'hierarchy',
        'identity',
        'authz',
        'audit',
        'approvals',
        'party_master',
        'attachments',
    ],
    optionalModules: ['finance'],
    integrationDeps: [],
    lifecycle: 'proposed',
    commercialRelease: 'phase_1',
    version: 1,
});
//# sourceMappingURL=module.manifest.js.map